export default "__VITE_ASSET__QSQ_WkHTSy9aO4fri9FIrA__"